<template>
  <v-layer ref="layer">
    <v-image :config="imageBg" />
    <v-image :config="imgLogo" />
    <v-image ref="arrow-orange-01" :config="imgArrowOrange1" />
    <v-image ref="arrow-orange-02" :config="imgArrowOrange2" />
    <v-image ref="arrow-yellow-01" :config="imgArrowYellow1" />
    <v-image ref="arrow-yellow-02" :config="imgArrowYellow2" />
  </v-layer>
</template>

<script>
import Konva from 'konva'
import ImageBg from '@/assets/event-ic-bg.png'
import ImageLogo from '@/assets/event-ic-bg-logo.png'
import ImageArrowOrange from '@/assets/event-ic-arrow-orange.png'
import ImageArrowYellow from '@/assets/event-ic-arrow-yellow.png'

import { help } from './help'

export default {
  mixins: [help],
  data() {
    return {
      imgLogo: {
        image: null,
        x: this.transformWH(35),
        y: this.transformWH(24)
      },
      imageBg: {
        image: null,
        x: this.transformWH(0),
        y: this.transformWH(0),
        width: this.getMaxSupportWidth()
      },
      imgArrowOrange: {
        image: null,
        x: this.transformWH(35),
        y: this.transformWH(24)
      },
      imgArrowYellow1: {
        image: null,
        x: this.transformWH(-80),
        y: this.transformWH(360),
        width: this.transformWH(80),
        height: this.transformWH(80)
      },
      imgArrowYellow2: {
        image: null,
        x: this.transformWH(-60),
        y: this.transformWH(1100),
        width: this.transformWH(60),
        height: this.transformWH(60)
      },
      imgArrowOrange1: {
        image: null,
        x: this.transformWH(-80),
        y: this.transformWH(560),
        width: this.transformWH(80),
        height: this.transformWH(80)
      },
      imgArrowOrange2: {
        image: null,
        x: this.transformWH(-60),
        y: this.transformWH(800),
        width: this.transformWH(60),
        height: this.transformWH(60)
      }
    }
  },
  async mounted() {
    await this.init()
    await this.startAnimation()
  },
  methods: {
    async init() {
      await this.placeImage(ImageBg, 'imageBg', false)
      await this.placeImage(ImageLogo, 'imgLogo')
      await this.placeImage(ImageArrowOrange, 'imgArrowOrange1', false)
      await this.placeImage(ImageArrowOrange, 'imgArrowOrange2', false)
      await this.placeImage(ImageArrowYellow, 'imgArrowYellow1', false)
      await this.placeImage(ImageArrowYellow, 'imgArrowYellow2', false)
    },
    async startAnimation() {
      const layer = this.$refs.layer.getNode()
      const maxWidth = this.getMaxSupportWidth()
      const animation01 = await this.createArrowAnimation(
        'arrow-yellow-01',
        230,
        1
      )
      const animation02 = await this.createArrowAnimation(
        'arrow-yellow-02',
        maxWidth,
        1.1
      )
      const animation03 = await this.createArrowAnimation(
        'arrow-orange-01',
        maxWidth,
        1.2
      )
      const animation04 = await this.createArrowAnimation(
        'arrow-orange-02',
        maxWidth,
        1.1
      )
      const layerAni = new Konva.Animation(() => {
        animation01()
        animation02()
        animation03()
        animation04()
      }, layer)

      layerAni.start()
    },
    async createArrowAnimation(ref, maxWidth, speed = 1) {
      const arrow = this.$refs[ref].getNode()
      await this.tryExistPromise(() => {
        return arrow.attrs.width
      })

      let counter = 0
      const clientWidth = this.getMaxSupportWidth()
      const arrowInitAttrsY = arrow.attrs.y
      const arrowInitAttrsX = arrow.attrs.x
      return () => {
        counter += 1 * speed
        const x = counter % clientWidth
        arrow.setX(x)
        arrow.setY(arrowInitAttrsY - x)
        if (x > maxWidth) {
          counter = arrowInitAttrsX
        }
      }
    }
  }
}
</script>
